var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinvetsalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1225",
    width: 229,
    height: 137,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1225h-2048z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1681,447)",
    d: "m0 0h103l4 5 14 27 26 52 10 19 20 39 15 29 12 22 13 26 10 19 17 33 10 20 10 19 15 29 5 8v2l-55 1h-27l-27-1-5-3-9-24-13-38-2-1-219-1-5 5-15 31-10 19-6 10-5 2-23 1h-14l-29-1-4-1-1-3v-73l2-10 12-22 22-43 6-10 6-4h12l8 1 1-19 1-43 3-12 12-21 11-17 15-26 16-28 10-16 1-1z",
    fill: "#621D67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,446)",
    d: "m0 0h37l3 1v56l-1 20h-114l-40 1-1 36v33h103v59l-1 17-1 1-100 1-1 3-1 119-1 1h-56l-42-1-1-51v-294l1-1z",
    fill: "#621D67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(441,568)",
    d: "m0 0h68l7 2 9 15 15 26 11 19 14 24 15 26 10 16 4 5 2 1-1-17v-116h73v63l-1 163-3 1h-80l-11-1-4-5-33-66-13-28-13-26h-2l-1 90-1 35h-65l-1-1v-224z",
    fill: "#788A2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,428)",
    d: "m0 0 5 3 26 30 9 11 12 13 12 14 1 3-3 1h-38l-9 26-14 41-28 84-15 43-12 36-16 47-6 14-1 1-27 1h-30l-28-1-3-2-17-49-17-47-13-36-16-44-13-36-3-12 8-1h60l11 34 14 48 24 80 2 2 7-25 9-35 17-58 16-57 12-44 2-11h-37l5-5 11-8 15-12 12-9 13-10 19-14 17-12z",
    fill: "#798B2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,447)",
    d: "m0 0h95l-1 16-7 54-7 49h-20l-3 10-6 54-18 146-3 19-28 1h-25l-57-1-4-2 7-25 18-70 32-128 8-33 2-7 3-4h11l2-70z",
    fill: "#798B2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,568)",
    d: "m0 0h116l57 1v19l-1 34-105 1-1 38 79 1 15 1-1 34-1 5-67 1-24 1v37l105 1 1 1-1 52-121 1h-50l-1-1-1-179v-43z",
    fill: "#788A2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1224,565)",
    d: "m0 0h42l27 2 29 4 1 4-4 15-8 24-1 4-12-2-26-4-13-1h-13l-16 2-13 5-6 7-1 2v6l4 6 10 6 14 6 37 13 20 9 14 8 11 9 8 10 6 13 3 14v8l-4 16-6 11-10 10-11 7-16 8-21 6-17 3-13 1h-33l-25-2-22-4-18-5-4-4 6-21 8-22 7 1 22 7 19 4 11 1h10l18-2 11-3 11-6 3-4v-7l-5-6-11-7-21-9-38-14-21-11-12-9-6-5-9-13-4-12-1-5v-14l3-11 6-12 8-9 10-8 14-8 16-6 23-5z",
    fill: "#788A2C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,568)",
    d: "m0 0h193l11 1v31l-1 22-68 1-1 22-1 150-6 1h-30l-27-1-1-17v-155l-65-1-5-1v-27z",
    fill: "#798B2C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1711,516)",
    d: "m0 0 4 2 15 28 23 45 14 27 16 31 6 8-1 4-21 1h-89l-40-1-1-2 3-7 4-6 8-16 16-31 10-19 9-17 12-22z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinvetsalogo);
export default __webpack_public_path__ + "static/media/finvetsa logo.537d35c88ef76063ce178d57cd5d4cb5.svg";
export { ForwardRef as ReactComponent };